import { render } from "./CDivider.vue?vue&type=template&id=27b0e562&scoped=true&ts=true"
import script from "./CDivider.vue?vue&type=script&lang=ts"
export * from "./CDivider.vue?vue&type=script&lang=ts"

import "./CDivider.vue?vue&type=style&index=0&id=27b0e562&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\ldcloud\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b0e562"]])

export default __exports__